const validTReference = /^T[0-9]{1,7}$/s
export default {
  getMessage (field, args) {
    return field
  },
  validate (value, args) {
    return validTReference.test(value)
  }
}
